import { Theme } from '@mui/material';

const useStyles = (theme: Theme) => ({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexDirection: 'column',
    backgroundColor: theme.palette.grey[50],
    overflowX: 'hidden',
    paddingBottom: '56px',
    overflowY: 'auto',
  },
  content: {
    display: 'flex',
    maxWidth: '1440px',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '16px',
    py: '24px',
    // overflowY: 'auto',
    [theme.breakpoints.down('lg')]: {
      padding: '24px',
    },
    // '::-webkit-scrollbar': {
    //   display: 'none',
    // },
  },
});

export default useStyles;
